import { useMutation } from '@apollo/client';
import { UserRowRoleType } from '@modules/users/store/types';
import { getUserTypeFromUserRowRole } from '@modules/users/utils';
import { InviteUserInput, Mutation } from 'generated/graphql';
import { useCallback } from 'react';
import { useGetUser } from 'v2/core/services/user';
import { INVITE_USERS } from './useInviteUsersByEmail';

interface UseInviteUsersByLinkOptions {
  onCompleted?: (inviteToken?: string) => void;
  onError?: () => void;
}

export const useInviteUsersByLink = ({
  onCompleted,
  onError,
}: UseInviteUsersByLinkOptions) => {
  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const [inviteUserMutation, { loading }] = useMutation<
    Mutation,
    InviteUserInput
  >(INVITE_USERS, {
    onError,
    onCompleted: (data) => {
      const inviteToken = data.inviteUser?.inviteToken;
      if (onCompleted && inviteToken) {
        onCompleted(inviteToken);
      }
    },
    notifyOnNetworkStatusChange: true,
  });

  const inviteUsersByLink = useCallback(
    async (userRole: UserRowRoleType) => {
      await inviteUserMutation({
        variables: {
          tenantID,
          emails: [],
          triggerInviteEmail: false,
          userType: getUserTypeFromUserRowRole(userRole),
        },
      });
    },
    [inviteUserMutation, tenantID],
  );

  return {
    inviteUsersByLink,
    isLoading: loading,
  };
};
